import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from '@ionic/react';
import { SignIn } from '@clerk/clerk-react';
import { useI18n } from '../i18n/I18nProvider';
import { loadPendingDeepLink } from '../lib/deepLinks';

const SignInPage: React.FC = () => {
  const { t } = useI18n();
  const pending = loadPendingDeepLink();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" text={t('common.actions.back')} />
          </IonButtons>
          <IonTitle>{t('auth.signIn.title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      
      <IonContent fullscreen className="ion-padding">
        <div className="auth-container">
          <SignIn
            appearance={{
              elements: {
                rootBox: {
                  width: '100%',
                  maxWidth: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                },
                card: {
                  boxShadow: 'none',
                  border: 'none',
                  width: '100%',
                  maxWidth: '400px',
                  margin: '0',
                },
                formButtonPrimary: {
                  backgroundColor: 'var(--ion-color-primary)',
                  borderRadius: '12px',
                  padding: '16px',
                  fontSize: '16px',
                  fontWeight: '600',
                },
                formFieldInput: {
                  borderRadius: '12px',
                  padding: '14px 16px',
                },
                footerActionLink: {
                  color: 'var(--ion-color-primary)',
                },
              },
            }}
            signUpUrl="/sign-up"
            forceRedirectUrl={pending || '/dashboard'}
          />
        </div>

        <style>{`
          .auth-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100%;
            width: 100%;
            padding: 0;
            box-sizing: border-box;
          }
          
          .auth-container > div {
            width: 100%;
            display: flex;
            justify-content: center;
          }
        `}</style>
      </IonContent>
    </IonPage>
  );
};

export default SignInPage;

